import React from 'react';
import ProjectSlider from './Sliders/ProjectSlider';
import BannerSlider from './Sliders/BannerSlider';

const Home = () => (
  <div className="body_container">
    <BannerSlider banner_id="home" />
    <div className="divider" />
    <ProjectSlider section="freeverse" />
    <ProjectSlider section="flash" />
    <div className="divider" />
    <ProjectSlider section="web" />
    <ProjectSlider section="3d" />
    <ProjectSlider section="misc" />
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js